import { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';
import { useDispatch } from 'react-redux';
import { setSnackbarData } from "@core/redux/actions/app/snackbar";

export default function SnackbarApp({ snackbarData }) {
    const dispatch = useDispatch();
    const { statusShow, statusAlert, titleAlert, textAlert } = snackbarData;

    const [open, setOpen] = useState(false);

    // sync open state เมื่อ snackbarData เปลี่ยน
    useEffect(() => {
        if (statusShow) {
            setOpen(true);
        }
    }, [statusShow]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;

        setOpen(false);
        dispatch(setSnackbarData({
            statusShow: false,
            statusAlert: "",
            titleAlert: "",
            textAlert: ""
        }));
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            key="topright"
            style={{ textAlign: "left", fontSize: "16px", zIndex: 99999 }}
        >
            <Alert severity={statusAlert} onClose={handleClose}>
                <AlertTitle style={{ fontSize: "18px" }}>
                    <span className="kanit">{titleAlert}</span>
                </AlertTitle>
                <span className="kanit">{textAlert}</span>
            </Alert>
        </Snackbar>
    );
}
